module.exports = __webpack_public_path__ + "img/组 1.726b3929.webp";